import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ContactUsPage from "./pages/ContactUsPage";
import ProfileReservationsPage from "./pages/ProfileReservationsPage";
import ProfileConfigPage from "./pages/ProfileConfigPage";
import AdminPage from "./pages/AdminPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AuthenticationModal from "./components/AuthenticationModal";
import UpdateNewUserModal from "./components/UpdateNewUserModal";
import Footer from "./components/Footer";
import NotFoundPage from "./pages/NotFoundPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./utils/ScrollToTop";
import GlobalStyles from "./styles/GlobalStyles";
import { useEffect } from "react";
import { useUserContext } from "./contexts/UserContext";
import CenovnikPage from "./pages/CenovnikPage";
// import SchedulerPage from "./pages/SchedulerPage";

export default function App() {
  const { token, validateToken } = useUserContext();

  useEffect(() => {
    validateToken(token);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path={"/"} element={<HomePage />} />
          <Route path={"/cenovnik"} element={<CenovnikPage />} />
            <Route path={"/galerija"} element={<AboutPage />} />
            <Route path={"/kontakt"} element={<ContactUsPage />} />
            {/*<Route path={"/zakazivanje"} element={<SchedulerPage />} />*/}
            {/*<Route path={"/servicos"} element={<ServicesPage />} />*/}
          {/*<Route path={"/sobre"} element={<AboutPage />} />*/}
          {/*<Route path={"/contato"} element={<ContactUsPage />} />*/}
            {/*<Route path={"/reservas"} element={<ProfileReservationsPage />} />*/}
            {/*<Route path={"/config"} element={<ProfileConfigPage />} />*/}
          {/*<Route path={"/admin"} element={<AdminPage />} />*/}
          <Route
            path={"/reset-password/:hash"}
            element={<ResetPasswordPage />}
          />
          <Route path={"/404"} element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <AuthenticationModal />
      <UpdateNewUserModal />
      <GlobalStyles />
      <ToastContainer />
    </>
  );
}
